import React, { useEffect } from 'react';
import cssReadAloudAns from './ReadAloudAns.module.scss'
// import Star from '../../../../Tool/Star/Star'

const COMP_NAME = "ReadAloudAns"

// #region Member Variables
let mblnInitialized = false
// #endregion Member Variables

function ReadAloudAns(props)
{
    console.log(COMP_NAME + ".Begin: ")
    console.log(COMP_NAME + ".Begin: props:", props)

    console.log(COMP_NAME + "props.ReadAloudAnswer: ", props.ReadAloudAnswer)
    console.log(COMP_NAME + "props.QuestionText: ", props.QuestionText)

    // #region Init State
    // #endregion Init State

    // #region Init Ref
    // #endregion Init Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)

        mblnInitialized = true
    }
    // #endregion First Launch   

    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
        }
    }, [])

    function GetRecordTextCls(UserAnswer, Index, Score)
    {
        console.log(COMP_NAME + ".GetRecordTextCls: ", UserAnswer)
        console.log(COMP_NAME + ".Index: ", Index)
        console.log(COMP_NAME + ".Score: ", Score)
        let objCls = cssReadAloudAns.spanRecordSymbolGray

        let intScore = Math.round(parseFloat(Score) * 100)
        if (intScore === 0)
        {
            objCls = cssReadAloudAns.spanRecordTextWrong
        }
        else if (intScore === 100)
        {
            objCls = cssReadAloudAns.spanRecordTextCorrect
        }
        else if (
            (UserAnswer !== null) &&
            (typeof (UserAnswer.CharScore) !== "undefined") &&
            (UserAnswer.CharScore.length > Index)
            )
        {
            if (UserAnswer.CharScore[Index] === -1)
            {
                objCls = cssReadAloudAns.spanRecordSymbolGray
            }
            else if (UserAnswer.CharScore[Index] < 0.6)
            {
                objCls = cssReadAloudAns.spanRecordTextWrong
            }
            else
            {
                objCls = cssReadAloudAns.spanRecordTextCorrect
            }
        }
        return objCls
    }

    function RenderAnswerTextWrapper(AnswerData)
    {
        console.log(COMP_NAME + ".RenderAnswerTextWrapper: ", AnswerData)

        let arrResultText = props.QuestionText.split("")

        // AnswerData.ScoreExtInfo
        // mobjAnswer.ScoreExtInfo = {
        //     "CharScore": arrCharScore
        // }
        // AnswerData.ScoreExtInfo.CharScore[Index]
        return (
            <>
                {arrResultText.map((ResultText, Index) =>
                    <span key={Index} className={GetRecordTextCls(AnswerData.UserAnswer, Index, AnswerData.Score)}>
                        {ResultText}
                    </span>
                )}
                {/* <span>{AnswerData.Score}</span> */}
            </>
        )
    }

    // function RenderScoreTextWrapper(AnswerData)
    // {
    //     console.log(COMP_NAME + ".RenderScoreTextWrapper:", AnswerData)
    //     return (
    //         <span className={GetClsAnswerScroe(AnswerData.Score)}>{AnswerData.Score}</span>
    //     )
    // }

    function RenderReadAloudAns(ReadAloudAnsObj)
    {
        console.log(COMP_NAME + ".RenderReadAloudAns: " + ReadAloudAnsObj)

        let objBlock = null
        // let strReadAloudAns = JSON.stringify(ReadAloudAnsObj)

        if (ReadAloudAnsObj !== null)
        {

            objBlock = <>
                {RenderAnswerTextWrapper(ReadAloudAnsObj)}
                {/* {RenderScoreTextWrapper(ReadAloudAnsObj)} */}
                {/* <Star Score={ReadAloudAnsObj.Score} FullMarks={100} TotalStarCount={5}/>  */}
                {/* <Star Score={80} FullMarks={200} TotalStarCount={10}/>  */}
                {/* <Star Score={ReadAloudAnsObj.Score} /> */}

                {/* <div style={{ width: 30, display: 'none' }}>{strReadAloudAns}</div> */}
            </>
        }
        else
        {
            // objBlock = <div style={{ width: 30 }}>{strReadAloudAns}</div>
        }

        return objBlock
    }

    // Similar to Render
    return (
        <div className={cssReadAloudAns.divSentenceWithSpeechRecognitionTextColorArea}>
            {RenderReadAloudAns(props.ReadAloudAnswer)}
        </div>
    )
}

export default ReadAloudAns
